import React from 'react';
import {FormDialog} from 'components/core';
import {TagsCtx} from 'components/dataProviders/tags';
import {OperationsCtx} from 'components/dataProviders/operations';


export default function Edit({operationID, open, onClose})
{
    const tagsCtx = React.useContext(TagsCtx);
    const opsCtx = React.useContext(OperationsCtx);
    const [loading, setLoading] = React.useState(false);
    const [tagItems, setTagItems] = React.useState([]);

      React.useEffect(function initializeTags() {
        let tags = [];
        tagsCtx.data.active.forEach((item) => tags.push({value: item.tagID, content: item.name}));
  
        setTagItems(tags);
    }, [tagsCtx]);

    const handleClose = () => {
        if(onClose) onClose();
      };
  
      const handleConfirm = (values) => {
        setLoading(true);
        opsCtx.funcs.update(operationID, values).then(() => {
          setLoading(false);
          handleClose();
        });
      }

    return <FormDialog
    open={open}
    onClose={handleClose}
    onConfirm={handleConfirm}
    title="Editar Ticket"
    subtitle="Cambia el nombre o las etiquetas para esta asistencia"
    confirm="Guardar"
    cancel="Cancelar"
    loading={loading}
    fields={[
      {
        type: "text",
        label: "Nombre del ticket",
        id: "name",
        placeholder: "",
        mandatory: true,
        value: opsCtx.data.indexed[operationID] ? opsCtx.data.indexed[operationID].name : ''
      },
      {
        type: "tagSelector",
        label: "Etiquetas",
        id: "tags",
        items: tagItems,
        value: opsCtx.data.indexed[operationID] ? opsCtx.data.indexed[operationID].tags : []
      }
    ]}
    />
}